export type BrandingImageValue = File | string;

export interface BrandingModel {
  // bannerImage: BrandingImageValue[] | null;
  carouselImages: BrandingImageValue[] | null;
  logo: BrandingImageValue[] | null;
  favicon: BrandingImageValue[] | null;
  primaryColor: string;
  secondaryColor: string;
  storeBackgroundColor?: string;
  textFieldActiveColor?: string;
  textFieldDisabledColor?: string;
  productHeadingText?: string;
  homepageProductCardBackground?: string;
  homepageProductNameBackground?: string;
  footerText?: string;
  companyName?: string;
  metaTitle?: string;
  metaDescription?: string;
}

export const DEFAULT_CAROUSEL_IMAGE =
  "https://developmentprocureasy.s3.ap-south-1.amazonaws.com/swagstore/40/new-banner.png";

export const createEmptyBranding = (): BrandingModel => ({
  // bannerImage: null,
  carouselImages: null,
  logo: null,
  favicon: null,
  primaryColor: "#1553CA",
  secondaryColor: "#D7458F",
  storeBackgroundColor: "#FFFFFF",
  textFieldActiveColor: "#FFFFFF",
  textFieldDisabledColor: "rgba(230, 230, 230, 1)",
  productHeadingText: "All Products",
  homepageProductCardBackground: "#FFFFFF",
  homepageProductNameBackground: "#FFFFFF",
  footerText: "",
  companyName: "",
  metaTitle: "",
  metaDescription: "",
});
